import EventBus from '@/eventBus';

export default {
  name: 'FiltrableTable',

  data() {
    return {
      bus: EventBus
    };
  },

  methods: {
    resetFilters() {
      this.bus.$emit('RESET');
    }
  }
};
